<template>
  <v-container
    id="user-profile-view"
    fluid
    tag="section"
    style="height: 80vh;"
    class="hero"
  >
    <v-row>
      <v-col cols="12" md="8">
        <v-card elevation="4" style="height: 70vh;">
          <v-toolbar color="warning" dark dense flat class="mb-1">
            <v-btn icon @click="$refs.calendar.prev()">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-progress-linear
              :active="tableLoading"
              :indeterminate="tableLoading"
              absolute
              bottom
              color="blue accent-4"
            ></v-progress-linear>

            <v-spacer></v-spacer>
            <v-btn icon @click="$refs.calendar.next()">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-toolbar>
          <v-sheet height="97%">
            <v-calendar
              ref="calendar"
              v-model="value"
              color="primary"
              :weekdays="weekday"
              :type="type"
              :events="events"
              @click:event="showEvent"
              @click:date="viewDay"
              @click:more="viewMore"
              :event-overlap-mode="mode"
              :event-overlap-threshold="30"
              :event-color="getEventColor"
              @change="getEvents"
            ></v-calendar>
          </v-sheet>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-row>
          <v-col cols="12">
            <v-card elevation="4" v-if="userid.charAt(0) != 'U'">
              <v-toolbar color="warning" dark dense flat class="mb-1">
                <v-toolbar-title> Performance</v-toolbar-title>

                <v-spacer></v-spacer>
                <v-btn @click="clickchart" icon>
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-toolbar>
              <v-sheet :style="chartheight">
                <apexchart
                  type="bar"
                  ref="chartb"
                  height="100%"
                  :options="chartOptionsb"
                  :series="seriesb"
                ></apexchart>
              </v-sheet>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card elevation="4" v-if="userid.charAt(0) != 'U'">
              <v-toolbar color="warning" dark dense flat class="mb-1">
                <v-toolbar-title>
                  Attendance
                </v-toolbar-title>

                <v-spacer></v-spacer>
                <v-btn icon @click="clickcharta">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-toolbar>
              <v-sheet :style="chartheight">
                <apexchart
                  type="bar"
                  ref="charta"
                  height="100%"
                  :options="chartOptions"
                  :series="seriesa"
                ></apexchart>
              </v-sheet>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogMore" max-width="400px">
      <v-card elevation="4">
        <v-toolbar dense color="secondary" dark>More</v-toolbar>
        <div class="center">
          <p class="text-h6 mx-5">
            Date : {{ formatDate(calendermoredate, "DD-MMM-YY") }}
          </p>
        </div>
        <div
          v-for="(item, index) in moreData"
          :key="index"
          :class="item.colourcode"
          class="mx-5 my-2 white--text"
        >
          {{ item.type }}
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogMore = false"
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<style scoped>
.hero {
  background: white;
}
.mycalender {
  height: 77vh;
}
</style>
<script>
import { get, sync } from "vuex-pathify";
import axios from "axios";
import { showSnackbar } from "../util/globalActions";
import VueApexCharts from "vue-apexcharts";
import download from "downloadjs";
//var percentage = 80;

import { formatDate } from "../util/helpers";
export default {
  name: "DashboardView",
  components: { apexchart: VueApexCharts },
  data: () => ({
    seriesb: [
      {
        data: [],
      },
    ],

    percent: 50,
    seriesa: [
      {
        data: [],
      },
    ],
    tableLoading: false,
    dialogMore: false,
    listingData: [],
    performanceData: [],
    attendanceData: [],
    type: "month",
    types: ["month", "week", "day", "4day"],
    mode: "stack",
    modes: ["stack", "column"],
    weekday: [0, 1, 2, 3, 4, 5, 6],
    weekdays: [
      { text: "Sun - Sat", value: [0, 1, 2, 3, 4, 5, 6] },
      { text: "Mon - Sun", value: [1, 2, 3, 4, 5, 6, 0] },
      { text: "Mon - Fri", value: [1, 2, 3, 4, 5] },
      { text: "Mon, Wed, Fri", value: [1, 3, 5] },
    ],
    value: "",
    events: [],
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party",
    ],
    moreData: [],
    chartdataIn: [],
    chartcategories: [],
    chartdataIna: [],
    chartcategoriesa: [],
    message: "",
    calendermoredate: null,
  }),
  created() {
    if (this.selectedfromdate != null) this.value = this.selectedfromdate;
    if (this.userid.charAt(0) != "U") {
      this.performance();

      this.attendance();
    }
  },
  computed: {
    name: get("route/name"),
    menuid: get("user/menuid"),
    userid: get("user/id"),
    apiUrl: get("app/apiUrl"),
    calenderselecteddate: sync("app/calenderselecteddate"),
    fromDashboard: sync("app/fromDashboard"),
    selecteduserid: sync("app/selecteduserid"),
    chartheight() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return "height: 40vh";
      } else {
        console.log(this.$vuetify.breakpoint.name);
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return "height: 26vh";
          case "sm":
            return "height: 26vh";
          case "md":
            return "height: 26vh";
          case "lg":
            return "height: 28vh";
          case "xl":
            return "height: 30vh";
          default:
            return "height: 30vh";
        }
      }
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },

    chartOptions: function() {
      return {
        chart: {
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        legend: {
          show: true,
        },
        tooltip: {
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return (
              "<table><tr><th>" +
              w.globals.labels[dataPointIndex] +
              '</th></tr><tr><td style="text-align: center;"><span>' +
              series[seriesIndex][dataPointIndex] +
              "</span>" +
              "</td></tr></table>"
            );
          },
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          min: 0,
          max: 100,
          title: {
            text: "Percentage",
          },
        },
      };
    },
    chartOptionsb: function() {
      return {
        chart: {
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: true,
        },
        legend: {
          show: true,
        },
        tooltip: {
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return (
              "<table><tr><th>" +
              w.globals.labels[dataPointIndex] +
              '</th></tr><tr><td style="text-align: center;"><span>' +
              series[seriesIndex][dataPointIndex] +
              "</span>" +
              "</td></tr></table>"
            );
          },
        },
        xaxis: {
          categories: [],
          labels: {
            style: {
              fontSize: "12px",
            },
          },
        },
        yaxis: {
          min: 0,
          max: 100,
          title: {
            text: "Percentage",
          },
        },
      };
    },
  },
  mounted() {},
  methods: {
    downloadfile() {
      axios
        .get(this.apiUrl + "api/Common/GePDF", {
          headers: this.headers,
          responseType: "blob", // had to add this one here
        })
        .then((response) => {
          const content = response.headers["content-type"];
          download(response.data, "E000026487.PDF", content);
        })
        .catch((error) => console.log(error));
    },
    downloadFile1() {
      //const specificationId = this.$route.params.specificationId;

      axios
        .get(this.apiUrl + `pdf/E000026487.PDF`, {
          headers: this.headers,
          responseType: "blob", // had to add this one here
        })
        .then((response) => {
          const content = response.headers["content-type"];
          download(response.data, "E000026487.PDF", content);
        })
        .catch((error) => console.log(error));
    },
    formatDate,

    clickchart() {
      const self = this;
      axios({
        url: this.apiUrl + "api/Common/getAcademicYear",
        method: "GET",
        responseType: "json",
      })
        .then(function(res) {
          console.log(res.data.fromDate);
          self.selectedfromdate = new Date(res.data.fromDate); //.format("YYYY-MM-DD"));
          self.selectedtodate = new Date(res.data.toDate); //.format("YYYY-MM-DD"));

          self.selecteduserid = self.userid;

          self.$router.push({ name: "Test performance" });
        })
        .catch(function(err) {
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },
    clickcharta() {
      const self = this;
      axios({
        url: this.apiUrl + "api/Common/getAcademicYear",
        method: "GET",
        responseType: "json",
      })
        .then(function(res) {
          console.log(res.data.fromDate);
          self.selectedfromdate = new Date(res.data.fromDate); //.format("YYYY-MM-DD"));
          self.selectedtodate = new Date(res.data.toDate); //.format("YYYY-MM-DD"));

          self.selecteduserid = self.userid;

          self.$router.push({ name: "Attendance Details" });
        })
        .catch(function(err) {
          self.message = err.status;

          showSnackbar({ message: "Data not found. Please try to Re-login." });
        });
    },
    getEvents({ start, end }) {
      const self = this;
      const events = [];

      const min = new Date(`${start.date}`);
      const max = new Date(`${end.date}`);
      self.tableLoading = true;
      const fromDate = min.toJSON();
      const toDate = max.toJSON();
      const data = {
        fromDate: fromDate,
        uptoDate: toDate,
      };
      self.events = [];
      axios({
        url: self.apiUrl + "api/Dashboard/dashboardcalender",
        data: data,
        method: "POST",
        responseType: "json",
      })
        .then(function(res) {
          self.listingData = res.data;
          self.tableLoading = false;

          self.listingData.forEach((element) => {
            //const allDay = true;
            const firstTimestamp = element.lcT_DT;
            const first = new Date(firstTimestamp);
            //const secondTimestamp = 288 * 900000;
            //const second = new Date(first.getTime() + secondTimestamp);

            events.push({
              name: element.type,
              start: first,
              color: element.colourcode,
            });

            self.events = events;
          });
        })
        .catch(function(err) {
          self.tableLoading = false;
          self.message = err.status;

          showSnackbar({ message: "Data not found. Please try to Re-login." });
        });
    },
    performance() {
      const self = this;
      const min = new Date();
      const max = new Date();

      self.tableLoading = true;
      const fromDate = min.toJSON();
      const toDate = max.toJSON();
      const data = {
        fromDate: fromDate,
        uptoDate: toDate,
      };

      axios({
        url: self.apiUrl + "api/Dashboard/dashboardperformance",
        data: data,
        method: "POST",
        responseType: "json",
      })
        .then(function(res) {
          self.performanceData = res.data;
          self.seriesb = [];

          res.data.forEach((element) => {
            //percentage = element.averageP;
            self.chartdataIn.push(element.peR_OBTAINED);

            self.chartcategories.push(element.suB_NAME);
          });
          self.seriesb.push({ data: self.chartdataIn });

          self.$refs.chartb.updateOptions({
            xaxis: {
              categories: self.chartcategories,
            },
          });
          //self.chartOptionsb.xaxis.categories = self.chartcategories;
        })
        .catch(function(err) {
          self.message = err.status;
          console.log(err);
          showSnackbar({ message: "Performance data not found!" });
        });
    },
    attendance() {
      const self = this;
      const min = new Date();
      const max = new Date();

      self.tableLoading = true;
      const fromDate = min.toJSON();
      const toDate = max.toJSON();
      const data = {
        fromDate: fromDate,
        uptoDate: toDate,
      };

      axios({
        url: self.apiUrl + "api/Dashboard/dashboardattendance",
        data: data,
        method: "POST",
        responseType: "json",
      })
        .then(function(res) {
          self.seriesa = [];
          res.data.forEach((element) => {
            //percentage = element.averageP;
            self.chartdataIna.push(element.per);

            self.chartcategoriesa.push(element.type);
          });
          self.seriesa.push({ data: self.chartdataIna });

          self.$refs.charta.updateOptions({
            xaxis: {
              categories: self.chartcategoriesa,
            },
          });
        })
        .catch(function(err) {
          self.message = err.status;
          console.log(err);
          showSnackbar({ message: "Performance data not found!" });
        });
    },
    findUnique(arr, predicate) {
      var found = {};
      arr.forEach((d) => {
        found[predicate(d)] = d;
      });
      return Object.keys(found).map((key) => found[key]);
    },
    getEventColor(event) {
      return event.color;
    },
    showEvent({ eventParsed }) {
      this.calenderselecteddate = new Date(eventParsed.start.date); //).format("YYYY-MM-DD");
      //this.selectedtodate = new Date(eventParsed.start.date); //).format("YYYY-MM-DD");
      this.fromDashboard = true;
      this.selecteduserid = this.userid;

      this.$router.push({ name: "Timetable" });
    },
    viewDay({ date }) {
      this.calenderselecteddate = new Date(date); //).format("YYYY-MM-DD");
      this.selecteduserid = this.userid;
      this.fromDashboard = true;
      this.$router.push({ name: "Timetable" });
    },
    viewMore({ date }) {
      this.calendermoredate = new Date(date); //).format("YYYY-MM-DD");
      console.log(this.calendermoredate);
      this.moreData = this.listingData.filter(
        (item) =>
          this.formatDate(item.lcT_DT, "DD-MMM-YYYY") ===
          this.formatDate(this.calendermoredate, "DD-MMM-YYYY")
      );
      this.dialogMore = true;
    },
  },
};
</script>
